export const FETCH_PO_LOCATIONS = 'FETCH_PO_LOCATIONS';
export const FETCH_PO_LOCATIONS_SUCCESS = 'FETCH_PO_LOCATIONS_SUCCESS';
export const FETCH_PO_LOCATIONS_ERROR = 'FETCH_PO_LOCATIONS_ERROR';

export const PO_LOCATION_UPDATED = 'PO_LOCATION_UPDATED';
